import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

// Scrolling announcement banner shown at the very top of the site.
export const AnnouncementBar = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/announcement`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d?.active && setData(d))
      .catch(() => {});
  }, []);

  // Expose banner height so the fixed header stack can offset below it.
  useEffect(() => {
    if (!data) return;
    document.documentElement.style.setProperty('--announce-h', '32px');
    return () => document.documentElement.style.setProperty('--announce-h', '0px');
  }, [data]);

  if (!data) return null;

  const content = (
    <span className="inline-flex items-center gap-3 px-8 text-[12px] md:text-[13px] font-medium tracking-wide">
      <Megaphone className="w-3.5 h-3.5 text-[#1F2A4A]" /> {data.message}
    </span>
  );

  const inner = (
    <div className="announcement-track flex whitespace-nowrap">
      {Array.from({ length: 8 }).map((_, i) => (
        <span key={i}>{content}</span>
      ))}
    </div>
  );

  return (
    <div className="bg-[#C9B896] text-[#1F2A4A] overflow-hidden relative" data-testid="announcement-bar">
      <style>{`
        @keyframes announcement-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .announcement-track { animation: announcement-scroll 55s linear infinite; width: max-content; }
        .announcement-track:hover { animation-play-state: paused; }
      `}</style>
      <div className="h-8 flex items-center">
        {data.link ? (
          <a href={data.link} className="block hover:opacity-80 transition-opacity">{inner}</a>
        ) : inner}
      </div>
    </div>
  );
};
